import * as TE from 'fp-ts/es6/TaskEither'
import { pipe } from 'fp-ts/es6/function'
import * as E from 'fp-ts/es6/Either'
import axios from 'axios'

export interface ErrorOutage {
  errorMessageToken: string
  instructionMessageToken: string
  isErrorOutage: boolean
}

export const DEFAULT_ERROR_OUTAGE = {
  errorMessageToken: 'INCIDENT_RESPONSE_GENERIC_ERROR_MESSAGE',
  instructionMessageToken: 'INCIDENT_RESPONSE_ERROR_CALL_TO_ACTION_MESSAGE',
  isErrorOutage: false,
}

const fetchErrorOutage = (): TE.TaskEither<Error, ErrorOutage> => {
  return pipe(
    TE.tryCatch(
      () =>
        axios.get(`/partner-directory-assets/aapn-incident-response.json`, {
          headers: { 'Content-Type': 'application/json', 'Cache-Control': 'no-cache' },
        }),
      reason => new Error(JSON.stringify(reason)),
    ),
    TE.chainEitherK(response => {
      if (response.data) {
        return E.right({
          errorMessageToken: response.data.error_message_token,
          instructionMessageToken: response.data.instruction_message_token,
          isErrorOutage: response.data.error_enabled,
        })
      } else {
        return E.left(new Error('Unexpected error getting error outage messages'))
      }
    }),
  )
}

export interface ErrorAndErrorOutage extends Error {
  errorOutage?: ErrorOutage
}

export const teGetErrorOutageData = (): TE.TaskEither<ErrorAndErrorOutage, ErrorOutage> => {
  return pipe(
    fetchErrorOutage(),
    TE.fold(
      // so that it doesn't break the whole app when axios call fails
      () => TE.of(DEFAULT_ERROR_OUTAGE),
      errorOutage => {
        return TE.right(errorOutage)
      },
    ),
  )
}
